/**
 * 점주 콘솔 v2 — 출시 알림/카테고리 관심 신청 API (master 전용).
 * 플랫폼 스코프 데이터라 storeId를 보내지 않는다.
 */
import api from '../../api/client';

/**
 * 신청자 명단.
 * params: { type: 'launch'|'category'|undefined, page, limit }
 * 응답: { total, page, limit, items: [{ id, type, category, email, phone, source, createdAt }] }
 */
export async function fetchInterestSignups(params = {}) {
  const res = await api.get('/interest-signups', { params });
  return res.data;
}

/** type·카테고리별 집계 — [{ category: 'launch'|'gym'|..., count }] */
export async function fetchInterestSignupStats() {
  const res = await api.get('/interest-signups/stats');
  return res.data;
}
